module.exports = require("vue");